'use client';

import Script from 'next/script';

import { useCookies } from '@personly/libs-providers';

const Quora = () => {
  const { consent } = useCookies();

  if (!consent.types.includes('TARGETING')) return;

  return (
    <Script
      id="quora"
      dangerouslySetInnerHTML={{
        __html: `
  !function(q,e,v,n,t,s){if(q.qp) return; n=q.qp=function(){n.qp?n.qp.apply(n,arguments):n.queue.push(arguments);}; n.queue=[];t=document.createElement(e);t.async=!0;t.src=v; s=document.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);}(window, 'script', 'https://a.quora.com/qevents.js');
  qp('init', '98b7ffb5cdc94592a07c6d35472822ea');
  qp('track', 'ViewContent');
  qp('track', 'Generic');
            `,
      }}
    />
  );
};

export default Quora;
